import { createSvgIcon } from '@mui/material';

export const TickIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="8" fill="#41CA00" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2288 10.8414L12.7006 6.791L13.966 7.87565L9.43775 13.1586L6.14111 10.4801L7.1921 9.18656L9.2288 10.8414Z"
      fill="#ECF4F9"
    />
  </svg>,
  'TickIcon',
);
